<template>
  <div class="imgsetting">
    <div class="imgsetting-tab">
      <div class="control-item" @click="fullscreen">
        <div class="control-item-title">
          全屏
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  methods: {
    fullscreen() {
      this.$emit('fullscreen')
    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.imgsetting {
  border-top: 1px solid $uni-text-color-placeholder;

  .imgsetting-tab {
    display: flex;
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 30;
    background: #FFFFFF;

    .control-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 50px;

      .control-item-title {
        font-size: 14px;

      }

      .control-item-icon {
      }
    }
  }
}


</style>
